<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title class="mt-2">
              <v-btn
                class="mr-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3 class="font-weight-bold">Coupon Usage</h3>
              <v-chip
                v-if="coupon.code"
                class="ml-4"
                small
                color="primary"
                text-color="white"
              >
                {{ coupon.code }}
              </v-chip>
            </v-card-title>
            <v-card-text v-if="coupon.id">
              <v-row>
                <v-col sm="3">
                  <v-card outlined rounded="xl" class="pa-4 text-center">
                    <div class="grey--text text--darken-1">Times Used</div>
                    <h2>
                      {{ coupon.used_count || 0
                      }}<span v-if="coupon.usage_limit" class="grey--text"
                        >/{{ coupon.usage_limit }}</span
                      >
                    </h2>
                  </v-card>
                </v-col>
                <v-col sm="3">
                  <v-card outlined rounded="xl" class="pa-4 text-center">
                    <div class="grey--text text--darken-1">Uses Left</div>
                    <h2>
                      {{
                        coupon.remaining_uses === null
                          ? "∞"
                          : coupon.remaining_uses
                      }}
                    </h2>
                  </v-card>
                </v-col>
                <v-col sm="3">
                  <v-card outlined rounded="xl" class="pa-4 text-center">
                    <div class="grey--text text--darken-1">
                      Total Discount Given
                    </div>
                    <h2>&#8377;{{ total_discount_given || 0 }}</h2>
                  </v-card>
                </v-col>
                <v-col sm="3">
                  <v-card outlined rounded="xl" class="pa-4 text-center">
                    <div class="grey--text text--darken-1">Influencer</div>
                    <h3>{{ coupon.influencer_name || "-" }}</h3>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 500px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="500"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left" style="min-width: 180px">
                        Customer
                      </th>
                      <th class="text-left" style="min-width: 130px">Phone</th>
                      <th class="text-left">Used On</th>
                      <th class="text-left">Order Amount</th>
                      <th class="text-left">Discount</th>
                      <th class="text-left">Paid</th>
                      <th class="text-left" style="min-width: 160px">
                        Used At
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="usages.length != 0">
                    <tr
                      v-for="(usage, i) in usages"
                      :key="`usage_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': usages.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ serialNoStarting + i + 1 }}
                      </td>
                      <td>{{ usage.user ? usage.user.user_name : "-" }}</td>
                      <td>{{ usage.user ? usage.user.phone : "-" }}</td>
                      <td>{{ usage.source_type }}</td>
                      <td>&#8377;{{ usage.order_amount }}</td>
                      <td class="green--text">
                        &#8377;{{ usage.discount_amount }}
                      </td>
                      <td>&#8377;{{ usage.final_amount }}</td>
                      <td style="min-width: 160px">
                        {{ formatDate(usage.used_at) }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">
                        This coupon has not been used yet
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "CouponUsagesPage",
  data() {
    return {
      coupon: {},
      usages: [],
      total_discount_given: 0,
      page: 1,
      serialNoStarting: 0,
      paginationLength: 0,
      count: 0,
      isLoading: false,
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(d.getDate())}-${pad(
          d.getMonth() + 1
        )}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
      } catch (e) {
        return value;
      }
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.couponId;
      let query = "page=" + this.page + "&rowsPerPage=" + this.rowsPerPage;
      await axios
        .get(`/coupons/${encryptedId}/usages?${query}`)
        .then((response) => {
          this.usages = response.data.data;
          this.coupon = response.data.coupon || {};
          this.total_discount_given = response.data.total_discount_given;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
  },
};
</script>
